import React, { useState, useEffect } from "react";
import { MdKeyboardArrowUp } from "@react-icons/all-files/md/MdKeyboardArrowUp";

import { useInView } from "react-intersection-observer";
import { useParams, Link } from "react-router-dom";
import Loadingnovel from "../components/Loadingnovel";
import { useSelector, useDispatch } from "react-redux";
import { getNovel, getNovelsChaps } from "../3- actions/novels";
import { unwrapResult } from "@reduxjs/toolkit";
import { CLEAR_CHAPTERS } from "../1- redux/chaps";
import ChapterSetting from "./ChapterSetting";
import { Helmet } from "react-helmet";

function NovelChapPage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const myLocation = window.location.href.split("/")[4];
  const currentNovel = useSelector((state) => state.novelsData.currentNovel);
  const currentChapters = useSelector((state) => state.novelsChaps.novelChaps);
  const [currentColor, setCurrentColor] = useState(1);
  const [currentSize, setCurrentSize] = useState(16);

  useEffect(() => {
    localStorage.setItem("ChapterFontSize", currentSize);
  }, [currentSize]);
  useEffect(() => {
    setCurrentColor(JSON.parse(localStorage.getItem("ChapterTheme") || 1));
    setCurrentSize(JSON.parse(localStorage.getItem("ChapterFontSize") || 16));
  }, []);
  // get me current index of chapter in my array of chapters
  const [indexOfChap, setIndexOfChap] = useState();
  const [currentChapter, setcurrentChapter] = useState();

  useEffect(() => {
    dispatch(getNovel(myLocation))
      .then(unwrapResult)
      .then((obj) => {
        dispatch(getNovelsChaps(obj.data._id))
          .then(unwrapResult)
          .then((obj) => {
            const index = obj?.map((c) => c._id).indexOf(id);
            setIndexOfChap(index);
          });
      });

    return () => {
      dispatch(CLEAR_CHAPTERS());
    };
  }, []);
  useEffect(() => {
    setcurrentChapter(currentChapters?.chapters?.[indexOfChap]);
  }, [indexOfChap, currentChapters?.chapters]);

  const [toggle, setToggle] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  });

  // numbersLogic
  function numbersLogic(num) {
    if (num >= 10 && num <= 99) {
      return "0" + num;
    }
    if (num <= 9) {
      return "00" + num;
    }
    return num;
  }
  return (
    <div className="">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${currentNovel?.novels?.title} Chapter ${
          currentChapters?.chapters?.length - indexOfChap
        } - EyeNovel`}</title>
      </Helmet>
      <div className="mt-[350px] max-w-[1300px] m-auto relative">
        <div
          className={
            currentColor === 1
              ? " px-[15px] md:px-10 lg:px-20 xl:px-32  flex flex-col bg-primary/10 duration-500 ease-in-out pt-32 pb-[300px] text-tertiary w-full h-full "
              : currentColor === 2
              ? " px-[15px] md:px-10 lg:px-20 xl:px-32  flex flex-col bg-primarys duration-500 ease-in-out pt-32 pb-[300px] text-secondary w-full h-full "
              : " px-[15px] md:px-10 lg:px-20 xl:px-32  flex flex-col bg-[#FFFBE6] duration-500 ease-in-out pt-32 pb-[300px] text-secondary w-full h-full "
          }
        >
          <div className="flex z-50 justify-center items-center text-center">
            <div
              ref={ref}
              className="w-full h-[380px] absolute top-0 -translate-y-[70%]"
            >
              <div className="w-[250px] h-[380px] m-auto">
                {inView ? (
                  <Link
                    to={`/novels/${myLocation}`}
                    className="rectangle w-[250px] h-full duration-500 ease-in-out object-cover"
                  >
                    {currentNovel.pending === true ? (
                      <div className="flex justify-center items-center bg-secondary  rectangle duration-[0] ease-in-out object-cover">
                        <div className="flex justify-center items-center bg-secondary opacity-20 rectangle duration-[0] ease-in-out object-cover">
                          <Loadingnovel />
                        </div>
                      </div>
                    ) : (
                      <img
                        className=" object-cover h-full w-full  z-10"
                        src={currentNovel?.novels?.selectedFile}
                        alt={currentNovel?.novels?.title}
                      />
                    )}
                  </Link>
                ) : (
                  <div className="flex justify-center items-center bg-secondary  rectangle duration-[0] ease-in-out object-cover">
                    <div className="flex justify-center items-center bg-secondary opacity-20 rectangle duration-[0] ease-in-out object-cover">
                      <Loadingnovel />
                    </div>
                  </div>
                )}
              </div>
              <ChapterSetting
                currentSize={currentSize}
                setCurrentSize={setCurrentSize}
                currentColor={currentColor}
                setCurrentColor={setCurrentColor}
              />
            </div>
            <div>
              <h1 className="mt-12 mb-6 md:mb-0 md:mt-16 break-all text-[25px] md:text-[32px] uppercase font-SoraS ">
                {currentNovel?.novels?.title}
              </h1>
            </div>
          </div>
          {!currentChapter ? (
            <div className=" h-[400px] relative">
              <div
                className="scale-125 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                role="status"
              >
                <svg
                  aria-hidden="true"
                  className="mr-2 w-8 h-8  animate-spin text-gray-600 fill-primary"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div>
              {/* top field */}
              <div className=" md:my-14 flex flex-col gap-y-16">
                <div className="w-full flex flex-wrap sm:flex-nowrap gap-y-2 gap-x-2 md:gap-x-4 ">
                  {/* PreviousNext Chapter */}
                  <Link
                    // jump to my next chapter by using +1 of my current index _id
                    to={`/novels/${myLocation}/${
                      currentChapters?.chapters?.[indexOfChap + 1]?._id
                    }`}
                    onClick={() => {
                      setIndexOfChap((prev) => prev + 1);
                      setToggle(false);
                    }}
                    className={
                      currentChapters?.chapters?.length === indexOfChap + 1
                        ? "w-full sm:w-1/6 lg:w-1/3 text-primary opacity-50 pointer-events-none bg-tertiary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center gap-x-2"
                        : "w-full sm:w-1/6 lg:w-1/3 text-primary bg-tertiary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center gap-x-2"
                    }
                  >
                    <MdKeyboardArrowUp className="-rotate-90 scale-125" />

                    <span className="hidden lg:block font-SoraR">
                      Previous Chapter
                    </span>
                  </Link>
                  <div className="w-full sm:w-2/3 lg:w-1/3 z-40 relative text-tertiary cursor-pointer  h-[52px] flex justify-between items-center gap-x-2">
                    <div className="flex relative items-center justify-between w-full">
                      <div
                        onClick={() => setToggle((prev) => !prev)}
                        className="px-6 bg-primary hover:bg-primary/90 duration-500 ease-in-out flex h-[52px] justify-between items-center w-full"
                      >
                        <span className="mr-4 line-clamp-1 w-full text-[14px] md:text-[16px] font-SoraR">
                          {currentChapter?.chapterName}
                        </span>
                        <MdKeyboardArrowUp
                          className={
                            toggle
                              ? "rotate-0 duration-500 ease-in-out scale-125"
                              : "rotate-180 duration-500 ease-in-out scale-125"
                          }
                        />
                      </div>
                      <div className=" absolute w-full bottom-0 translate-y-full ">
                        <div
                          className={
                            toggle
                              ? "w-full z-50 relative max-h-[300px] duration-500 ease-in-out overflow-y-scroll"
                              : "w-full z-50 relative max-h-[0px] duration-500 ease-in-out overflow-y-scroll"
                          }
                        >
                          {currentChapters?.chapters?.map((chapter, index) => {
                            return (
                              <div key={index}>
                                <Link
                                  to={`/novels/${myLocation}/${chapter._id}`}
                                >
                                  <div
                                    onClick={() => {
                                      setToggle(false);
                                      setIndexOfChap(index);
                                    }}
                                    className="py-0 my-0  px-6 text-[14px] md:text-[16px] flex justify-start items-center h-[52px] w-full text-secondary bg-tertiary hover:bg-primary hover:text-tertiary font-SoraR duration-500 ease-in-out "
                                  >
                                    <p className="line-clamp-1 w-full">
                                      Chap{" "}
                                      {numbersLogic(
                                        currentChapters?.chapters?.length -
                                          index
                                      )}{" "}
                                      : {chapter?.chapterName}
                                    </p>
                                  </div>
                                </Link>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Next Chapter */}
                  <Link
                    // jump to my previous chapter by using -1 of my current index _id
                    to={`/novels/${myLocation}/${
                      currentChapters?.chapters?.[indexOfChap - 1]?._id
                    }`}
                    onClick={() => {
                      setIndexOfChap((prev) => prev - 1);
                      setToggle(false);
                    }}
                    className={
                      indexOfChap === 0
                        ? "w-full sm:w-1/6 lg:w-1/3 text-tertiary opacity-50 pointer-events-none bg-primary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center flex-row-reverse gap-x-2"
                        : "w-full sm:w-1/6 lg:w-1/3 text-tertiary bg-primary cursor-pointer hover:bg-primary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center flex-row-reverse gap-x-2"
                    }
                  >
                    <MdKeyboardArrowUp className="rotate-90 scale-125" />
                    <span className="hidden lg:block font-SoraR">
                      Next Chapter
                    </span>
                  </Link>
                </div>
                <div className="w-full flex justify-center items-center text-center gap-x-4 ">
                  <div
                    className={
                      currentColor === 1
                        ? "w-full md:w-1/3 h-[1px] bg-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                        : "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                    }
                  ></div>
                  <h2
                    className={
                      currentColor === 1
                        ? "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#282435]/80"
                        : "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#282435]/80"
                    }
                  >
                    EyeNovel
                  </h2>
                  <div
                    className={
                      currentColor === 1
                        ? "w-full md:w-1/3 h-[1px] bg-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                        : "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                    }
                  ></div>
                </div>
              </div>
              <div className="py-24 flex flex-col gap-y-4">
                <h1 className="font-SoraS break-words w-full text-[20px] md:text-[24px]">
                  Chapter{" "}
                  {numbersLogic(
                    currentChapters?.chapters?.length - indexOfChap
                  )}{" "}
                  : {currentChapter?.chapterName}
                </h1>
                <p
                  style={{ fontSize: currentSize + "px" }}
                  className={
                    currentColor === 1
                      ? "text-[#D9D9D9]/70 leading-[3] whitespace-pre-line break-words w-full"
                      : currentColor === 2
                      ? "text-[#282435] leading-[3] whitespace-pre-line break-words w-full"
                      : "text-[#282435] leading-[3] whitespace-pre-line break-words w-full"
                  }
                >
                  {currentChapter?.chapterBody}
                </p>
              </div>
              {/* bottom field */}
              <div className=" md:my-14 flex flex-col gap-y-16">
                <div className="w-full flex flex-wrap sm:flex-nowrap gap-y-2 gap-x-2 md:gap-x-4 ">
                  {/* PreviousNext Chapter */}
                  <Link
                    // jump to my next chapter by using +1 of my current index _id
                    to={`/novels/${myLocation}/${
                      currentChapters?.chapters?.[indexOfChap + 1]?._id
                    }`}
                    onClick={() => {
                      setIndexOfChap((prev) => prev + 1);
                      setToggle(false);
                    }}
                    className={
                      currentChapters?.chapters?.length === indexOfChap + 1
                        ? "w-full sm:w-1/6 lg:w-1/3 text-primary opacity-50 pointer-events-none bg-tertiary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center gap-x-2"
                        : "w-full sm:w-1/6 lg:w-1/3 text-primary bg-tertiary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center gap-x-2"
                    }
                  >
                    <MdKeyboardArrowUp className="-rotate-90 scale-125" />

                    <span className="hidden lg:block font-SoraR">
                      Previous Chapter
                    </span>
                  </Link>
                  <div className="w-full sm:w-2/3 lg:w-1/3 z-40 relative text-tertiary cursor-pointer  h-[52px] flex justify-between items-center gap-x-2">
                    <div className="flex relative items-center justify-between w-full">
                      <div
                        onClick={() => setToggle((prev) => !prev)}
                        className="px-6 bg-primary hover:bg-primary/90 duration-500 ease-in-out flex h-[52px] justify-between items-center w-full"
                      >
                        <span className="mr-4 line-clamp-1 w-full text-[14px] md:text-[16px] font-SoraR">
                          {currentChapter?.chapterName}
                        </span>
                        <MdKeyboardArrowUp
                          className={
                            toggle
                              ? "rotate-0 duration-500 ease-in-out scale-125"
                              : "rotate-180 duration-500 ease-in-out scale-125"
                          }
                        />
                      </div>
                      <div className=" absolute w-full bottom-0 translate-y-full ">
                        <div
                          className={
                            toggle
                              ? "w-full z-50 relative max-h-[300px] duration-500 ease-in-out overflow-y-scroll"
                              : "w-full z-50 relative max-h-[0px] duration-500 ease-in-out overflow-y-scroll"
                          }
                        >
                          {currentChapters?.chapters?.map((chapter, index) => {
                            return (
                              <div key={index}>
                                <Link
                                  to={`/novels/${myLocation}/${chapter._id}`}
                                >
                                  <div
                                    onClick={() => {
                                      setToggle(false);
                                      setIndexOfChap(index);
                                    }}
                                    className="py-0 my-0  px-6 text-[14px] md:text-[16px] flex justify-start items-center h-[52px] w-full text-secondary bg-tertiary hover:bg-primary hover:text-tertiary font-SoraR duration-500 ease-in-out "
                                  >
                                    <p className="line-clamp-1 w-full">
                                      Chap{" "}
                                      {numbersLogic(
                                        currentChapters?.chapters?.length -
                                          index
                                      )}{" "}
                                      : {chapter?.chapterName}
                                    </p>
                                  </div>
                                </Link>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Next Chapter */}
                  <Link
                    // jump to my previous chapter by using -1 of my current index _id
                    to={`/novels/${myLocation}/${
                      currentChapters?.chapters?.[indexOfChap - 1]?._id
                    }`}
                    onClick={() => {
                      setIndexOfChap((prev) => prev - 1);
                      setToggle(false);
                    }}
                    className={
                      indexOfChap === 0
                        ? "w-full sm:w-1/6 lg:w-1/3 text-tertiary opacity-50 pointer-events-none bg-primary cursor-pointer hover:bg-tertiary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center flex-row-reverse gap-x-2"
                        : "w-full sm:w-1/6 lg:w-1/3 text-tertiary bg-primary cursor-pointer hover:bg-primary/90 duration-500 ease-in-out h-[52px] flex justify-center items-center flex-row-reverse gap-x-2"
                    }
                  >
                    <MdKeyboardArrowUp className="rotate-90 scale-125" />
                    <span className="hidden lg:block font-SoraR">
                      Next Chapter
                    </span>
                  </Link>
                </div>
                <div className="w-full flex justify-center items-center text-center gap-x-4 ">
                  <div
                    className={
                      currentColor === 1
                        ? "w-full md:w-1/3 h-[1px] bg-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                        : "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                    }
                  ></div>
                  <h2
                    className={
                      currentColor === 1
                        ? "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#282435]/80"
                        : "w-full mx-4 whitespace-nowrap md:w-1/3 uppercase font-SoraL text-[13px] md:text-[14px] text-[#282435]/80"
                    }
                  >
                    EyeNovel
                  </h2>
                  <div
                    className={
                      currentColor === 1
                        ? "w-full md:w-1/3 h-[1px] bg-[#D9D9D9]/70"
                        : currentColor === 2
                        ? "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                        : "w-full md:w-1/3 h-[1px] bg-[#282435]/40"
                    }
                  ></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NovelChapPage;
